import { MinimalSymbol } from 'features/processFlowDiagrams/data/MinimalSymbols'
import Crusher from 'features/processFlowDiagrams/svg/crushers-grinding/crusher.svg?react'
import CrusherCone from 'features/processFlowDiagrams/svg/crushers-grinding/crusher-cone.svg?react'
import CrusherHammer from 'features/processFlowDiagrams/svg/crushers-grinding/crusher-hammer.svg?react'
import CrusherImpact from 'features/processFlowDiagrams/svg/crushers-grinding/crusher-impact.svg?react'
import CrusherJaw from 'features/processFlowDiagrams/svg/crushers-grinding/crusher-jaw.svg?react'
import CrusherRoller from 'features/processFlowDiagrams/svg/crushers-grinding/crusher-roller.svg?react'
import CrushingGrindingMachine from 'features/processFlowDiagrams/svg/crushers-grinding/crushing-grinding-machine.svg?react'
import MillPulverizer from 'features/processFlowDiagrams/svg/crushers-grinding/mill-pulverizer.svg?react'
import MillPulverizerHammer from 'features/processFlowDiagrams/svg/crushers-grinding/mill-pulverizer-hammer.svg?react'
import MillPulverizerImpact from 'features/processFlowDiagrams/svg/crushers-grinding/mill-pulverizer-impact.svg?react'
import MillRoller from 'features/processFlowDiagrams/svg/crushers-grinding/mill-roller.svg?react'
import MillVibration from 'features/processFlowDiagrams/svg/crushers-grinding/mill-vibration.svg?react'
import React from 'react'

export const PID_CRUSHERS_GRINDING_SYMBOLS: MinimalSymbol[] = [
  {
    id: 'crusher',
    name: 'Crusher',
    category: 'crushers-grinding',
    svgContent: <Crusher />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crusher-cone',
    name: 'Crusher (Cone)',
    category: 'crushers-grinding',
    svgContent: <CrusherCone />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crusher-hammer',
    name: 'Crusher (Hammer)',
    category: 'crushers-grinding',
    svgContent: <CrusherHammer />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crusher-impact',
    name: 'Crusher (Impact)',
    category: 'crushers-grinding',
    svgContent: <CrusherImpact />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crusher-jaw',
    name: 'Crusher (Jaw)',
    category: 'crushers-grinding',
    svgContent: <CrusherJaw />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crusher-roller',
    name: 'Crusher (Roller)',
    category: 'crushers-grinding',
    svgContent: <CrusherRoller />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'crushing-grinding-machine',
    name: 'Crushing, Grinding Machine',
    category: 'crushers-grinding',
    svgContent: <CrushingGrindingMachine />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'mill-pulverizer',
    name: 'Mill, Pulverizer',
    category: 'crushers-grinding',
    svgContent: <MillPulverizer />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'mill-pulverizer-hammer',
    name: 'Mill, Pulverizer (Hammer)',
    category: 'crushers-grinding',
    svgContent: <MillPulverizerHammer />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'mill-pulverizer-impact',
    name: 'Mill, Pulverizer (Impact)',
    category: 'crushers-grinding',
    svgContent: <MillPulverizerImpact />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'mill-roller',
    name: 'Mill (Roller)',
    category: 'crushers-grinding',
    svgContent: <MillRoller />,
    viewBox: '0 0 100 60',
  },
  {
    id: 'mill-vibration',
    name: 'Mill (Vibration)',
    category: 'crushers-grinding',
    svgContent: <MillVibration />,
    viewBox: '0 0 100 60',
  },
]
